import { primaryColor, borderColor, orangeLabelColor, selectedRowColor } from 'assets/jss/material-dashboard-pro-react';

const simpleTabsStyle = (theme) => ({
	tabsWrapper: {
		display: 'flex',
		justifyContent: 'left',
		borderBottom: `1px solid ${borderColor}`,
	},
	tabWrapper: {
		padding: '8px 24px',
		borderBottom: '2px solid transparent',
		cursor: 'pointer',
		'& p': {
			textAlign: 'center',
			marginBottom: 0,
		},
	},
	activeTabWrapper: {
		borderBottomColor: primaryColor[0],
		backgroundColor: selectedRowColor,
	},
	contentWrapper: {},
	labelWrapper: {
		display: 'flex',
		[theme.breakpoints.down('xs')]: {
			display: 'inline-block',
		},
	},
	label: {
		marginLeft: '5px',
		color: `${orangeLabelColor} !important`
	}
});

export default simpleTabsStyle;
